import { color } from '@metro-ui/tokens/js';
var borderColors = {
    default: color.palette.blue.tint[40],
    hasError: color.palette.red.tint[40],
    isDisabled: color.palette.grey.tint[80],
};
export var getBorderColor = function (_a) {
    var hasError = _a.hasError, isDisabled = _a.isDisabled;
    if (hasError)
        return borderColors.hasError;
    if (isDisabled)
        return borderColors.isDisabled;
    return borderColors.default;
};
export var getBackgroundColor = function (_a) {
    var hasError = _a.hasError, isDisabled = _a.isDisabled, isChecked = _a.isChecked;
    if (!isChecked)
        return color.inverted;
    if (hasError)
        return color.palette.red.tint[90];
    if (isDisabled)
        return color.palette.grey.tint[90];
    return color.palette.blue.tint[90];
};
//# sourceMappingURL=tokens.js.map